import { Component, computed, effect, inject, input, output, signal } from '@angular/core';
import { buttonColor, TextNodeType } from '@mwe/models';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { BasicCardComponent } from '../cards/basic-card/basic-card.component';
import { ButtonComponent } from '../buttons/button/button.component';
import { HeadlineComponent } from '../headline/headline.component';
import { StaticContentService } from '@mwe/services';
import { SafeHtmlPipe } from '@mwe/ui/pipes';
import { TranslatePipe } from '@ngx-translate/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { HeadlineService } from '@mwe/ui/components';

@Component({
  selector: 'mwe-teaser',
  templateUrl: './teaser.component.html',
  imports: [BasicCardComponent, ButtonComponent, NgTemplateOutlet, HeadlineComponent, SafeHtmlPipe, TranslatePipe, NgClass],
  providers: [HeadlineService],
})
export class TeaserComponent {
  private readonly staticContentService = inject(StaticContentService);

  readonly ctaClick = output<void>();
  readonly closeClick = output<void>();
  readonly showCloseBtn = input<boolean>(false);
  readonly initialVisibility = input<boolean>(true);
  readonly headlineText = input<string>('');
  readonly staticImage = input<string>('');
  readonly ctaLabel = input<string>('');
  readonly messageKeys = input<string[]>();
  readonly variant = input<'card' | 'outline'>('card');
  readonly alignment = input<'left' | 'center' | 'right'>('left');
  readonly headingNodeType = input<TextNodeType>('h5');
  readonly placeholderMap = input<Map<string, string>>();

  readonly isVisible = signal<boolean>(true);
  readonly staticImagePath = computed<string>(() => this.staticContentService.getImagePath() + this.staticImage());
  readonly alignmentClass = computed<string>(() => {
    switch (this.alignment()) {
      case 'left':
        return 'text-start';
      case 'center':
        return 'text-center';
      case 'right':
        return 'text-end';
    }
  });
  readonly rowAlignmentClass = computed<string>(() => {
    switch (this.alignment()) {
      case 'left':
        return 'justify-content-start';
      case 'center':
        return 'justify-content-center';
      case 'right':
        return 'justify-content-end';
    }
  });
  readonly ctaColor = computed<buttonColor>(() => {
    switch (this.variant()) {
      case 'card':
        return 'dark-blue';
      case 'outline':
        return 'blue';
    }
  });
  readonly translateValues = computed<{ [key: string]: string | number }>(() => {
    if (!this.placeholderMap()) return {};
    return [...this.placeholderMap().entries()]?.reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: value,
      }),
      {},
    );
  });

  constructor() {
    effect(() => {
      this.isVisible.set(this.initialVisibility());
    });
  }

  onCloseButton(): void {
    this.isVisible.set(false);
    this.closeClick.emit();
  }
}
